
const { doExec } = require('./request')

module.exports = {
    // 栏目详情
    getColumn (opts) {
        return doExec(`mobile/column/column/${opts.id || opts.cId || opts.columnId}`, opts, null, 'get')
    }
}